/**
 * Application Bundle Entry Point
 * This file imports all modules in the correct dependency order
 * Rollup will automatically resolve dependencies and create a single optimized bundle
 */

// ===== Foundation (Base classes and utilities) =====
import './fields.js';
import './styleSheet.js';
import './tasks.js';
import './tabValidator.js';
import './formValidator.js';

// ===== Services =====
import './services/api-client.js';

// ===== UI Utilities =====
import './ui/abort-controller-manager.js';
import './ui/input-preserver.js';

// ===== UI Components (Alphabetically organized) =====
import './DatePickerAdaptor.js';
import './accountPanel.js';
import './alertModal.js';
import './publicConfirmModal.js';
import './passwordStrength.js';
import './acte.js';
import './acteComponent.js';
import './acteComponentExtended.js';
import './acteComponentMini.js';
import './adminModification.js';
import './adminParting.js';
import './adminPartingList.js';
import './administratorContainer.js';
import './administratorPersonneMorale.js';
import './administratorPersonneMoraleList.js';
import './administratorPersonnePhysique.js';
import './administratorPersonnePhysiqueList.js';
import './auditorsModification.js';
import './autocompleteVille.js';
import './autocompleteVilleContact.js';
import './budgetComponent.js';
import './buttonCategory.js';
import './capital.js';
import './cessionnaire.js';
import './commissaireAuxComptesModification.js';
import './commissionerContainer.js';
import './admissionConditionsContainer.js';
import './directionModification.js';
import './directorContainer.js';
import './directorModification.js';
import './directorParting.js';
import './directorPartingList.js';
import './greffe.js';
import './headOffice.js';
import './managerList.js';
import './managerModification.js';
import './mandateContainer.js';
import './nominationsContainer.js';
import './nominationsContainerSAS.js';
import './objectModificationRadioButtons.js';
import './oldGreffe.js';
import './oppositions.js';
import './personneContainer.js';
import './personneContainerCession.js';
import './personneModificationContainer.js';
import './personneMorale.js';
import './personneMoraleCession.js';
import './personneMoraleDirector.js';
import './personneMoraleDirectorList.js';
import './personneMoraleDirectorModification.js';
import './personneMoraleDirectorModificationList.js';
import './personneMoraleExtended.js';
import './personneMoraleExtendedList.js';
import './personneMoraleList.js';
import './personneMoraleModification.js';
import './personneMoraleModificationList.js';
import './personneMoraleTransformationList.js';
import './personnePhysique.js';
import './personnePhysiqueCession.js';
import './personnePhysiqueDirector.js';
import './personnePhysiqueDirectorList.js';
import './personnePhysiqueDirectorModification.js';
import './personnePhysiqueDirectorModificationList.js';
import './personnePhysiqueList.js';
import './personnePhysiqueModification.js';
import './personnePhysiqueModificationList.js';
import './presidentContainer.js';
import './selectFromAPI.js';
import './signature.js';
import './staticSelects.js';
import './transformationList.js';

// ===== Feature Modules =====
import './features/category/category-controller.js';
import './features/category/category-validator.js';
import './features/category/category-module.js';

import './features/legal/legal-controller.js';
import './features/legal/legal-validator.js';
import './features/legal/legal-module.js';

// ===== Admin Components =====
import './admin/adminPagination.js';

console.log('Application bundle loaded successfully');
